<template>
  <div style="height: 100%">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">堆物堆料打卡管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>{{ dialogType }}</div>
        </div>
      </div>
    </div>
    <div
      class="section"
      style="padding: 0;padding-bottom: 20px;position: relative;"
    >
      <div class="box box-between p-15">
        <div class="box box-column-center">
          <img
            src="@/assets/image/company1.png"
            style="width: 72px;height: 72px;margin-right: 16px;"
          />
          <div>
            <div class="topName">建筑物名称：{{ currentItem && currentItem.buildingName }}</div>
          </div>
        </div>
        <div class="box">
          <el-button style="font-size: 16px" @click="cancel" size="mini">
            <template class="box box-column-center">
              <!-- <img src="@/assets/image/back.png" style="width: 14px; height: 14px;margin-right: 5px;" /> -->
              <span>返回</span>
            </template>
          </el-button>
        </div>
      </div>
      <div class="line"></div>
      <div
        class="box box-column p-15"
        style="width: 100%;height: 70vh;overflow-y: auto;"
      >
        <div class="title mb-20">基本信息</div>
        <div class="info box box-column">
          <div class="box box-1">
            <div class="box-1 item tagBg">建筑物名称</div>
            <div class="box-3 item-bottom">{{ currentItem && currentItem.buildingName }}</div>
            <div class="box-1 item-bottom"></div>
            <div class="box-3 item-right"></div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">所属社区</div>
            <div class="box-3 item">{{ currentItem && currentItem.communityName }}</div>
            <div class="box-1 item tagBg">建筑物类型</div>
            <div class="box-3 item">{{ currentItem && currentItem.buildingType ? jzwListValue[currentItem.buildingType] : '' }}</div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">负责社工</div>
            <div class="box-3 item">{{ currentItem && currentItem.typeWorker }}</div>
            <div class="box-1 item tagBg">联系电话</div>
            <div class="box-3 item">{{ currentItem && currentItem.typeWorkerPhone }}</div>
          </div>
        </div>
        <div class="title mt-20 mb-20">打卡记录</div>
        <div class="row-list mb-20" v-if="clockRecords.length">
          <span v-for="(item, index) in clockRecords"
          :key="index" :class="currentIndex == index ? 'row-active' : ''" class="row-item" @click="() => {currentIndex = index; getFullDetail();}">第{{ index + 1 }}次打卡</span>
        </div>
        <div class="box box-center" style="height: 50vh;" v-else><span>暂无数据</span></div>
        <div
          v-for="(item, index) in clockRecords"
          :key="index"
          class="clock-item mb-20 box box-column"
          v-show="currentIndex == index"
        >
          <div class="box">
            <div
              class="box-1"
              style="border: 1px solid #E0E0E0;"
            >
              <div class="box box-1 box-column-center citems">
                <img
                  src="@/assets/image/dakaxq.png"
                  style="width: 24px;height: 24px;"
                />
                <span class="dakaNums ml-10">打卡详情</span>
              </div>
              <div style="padding: 24px;">
                <div class="box box-column-center mb-10">
                  <div class="box-1 box box-column-center">
                    <span class="rlabel">打卡人</span>
                    <div class="rvalue">{{ item.userUsername }}</div>
                  </div>
                </div>
                <div class="box box-column-center mb-10">
                  <div class="box-1 box box-column-center">
                    <span class="rlabel">打卡时间</span>
                    <div class="rvalue box-1 box box-wrap">{{ item.createTime }}</div>
                  </div>
                </div>
                <div class="box box-column-center mb-10">
                  <div class="box-1 box box-column-center">
                    <span class="rlabel">事项说明</span>
                    <div class="rvalue box-1 box box-wrap">{{ item.remark }}</div>
                  </div>
                </div>
                <div class="rlabel">打卡照片</div>
                <div class="box box-column-center mb-10">
                  <!-- <div class="box-1 box box-column-center">
                    <span class="rlabel">打卡照片</span>
                    <div class="box-1 box box-wrap" v-if="item.fileJson">
                      <div
                        class="img-item"
                        v-for="(items, indexs) in item.fileJson &&
                          JSON.parse(item.fileJson)"
                        :key="indexs"
                      >
                        <img :src="items.url" />
                        <span v-if="items.indexName">{{ items.indexName }}</span>
                      </div>
                    </div>
                  </div> -->
                  <el-carousel class="box-1" height="200px" :interval="3000" arrow="always">
                    <el-carousel-item v-for="(items, indexs) in item.fileJson &&
                          JSON.parse(item.fileJson)"
                        :key="indexs">
                        <!-- <img :src="items.url" style="object-fit: cover;"/> -->
                        <el-image :src="items.url" fit="cover" :preview-src-list="item.fileJson &&
                          JSON.parse(item.fileJson).map(o => o.url)" style="height: 200px;"></el-image>
                        <!-- <span v-if="items.indexName">{{ items.indexName }}</span> -->
                    </el-carousel-item>
                  </el-carousel>
                </div>
                <div class="mb-10 box box-column">
                  <div class="box-1 box box-column-center">
                    <span class="rlabel">打卡地址</span>
                  </div>
                  <div class="box-1 box box-column">
                    <div class="map-content mb-20">
                      <MapCom
                        :index="index"
                        :pointInfo="{
                          reportAddressLong:
                            item.longAndLat && item.longAndLat.split(',')[0],
                          reportAddressLat:
                            item.longAndLat && item.longAndLat.split(',')[1]
                        }"
                      ></MapCom>
                    </div>
                    <div class="box box-column-center mt-20">
                      <i class="el-icon-location-outline mr-10"></i>
                      <span class="rvalue">{{ item.createAddress }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin: 0 5px;">
              <img src="@/assets/image/nextTo.png" alt="">
            </div>
            <div
              class="box-1"
              style="border: 1px solid #E0E0E0;position: relative;"
            >
              <div class="box box-1 box-column-center citems">
                <img
                  src="@/assets/image/Aishibie.png"
                  style="width: 24px;height: 24px;"
                />
                <span class="dakaNums ml-10">AI智能识别</span>
              </div>
              <div style="padding: 12px;">
                <div class="box box-column" style="height: 500px; overflow: auto;">
                  <div v-for="(items, indexs) in item.aiTaskList" :key="indexs" class="mb-10" v-show="items.httpIsOk"> <!-- && items.httpIsOk == 'true' -->
                    <div style="border: 1px solid #dfe5e8;" class="box box-1">
                      <div class="box-1 box">
                        <el-image :src="items.backImgUrl" class="box-1" style="height: 146px;" :preview-src-list="[items.backImgUrl]"></el-image>
                      </div>
                      <div class="box-1 box box-column" style="justify-content: center;padding-left: 10px;">
                        <!-- 合格 -->
                        <img src="@/assets/image/hege.png" v-if="items.backBreakRule == 'false'" alt="" style="width: 52px;height: 24px;">
                        <!-- 不合格 -->
                        <img src="@/assets/image/buhege.png" v-if="items.backBreakRule == 'true'" alt="" style="width: 52px;height: 24px;">
                        <img src="@/assets/image/sbyc.png" v-if="items.httpIsOk == 'false'" style="width: 102px;height: 24px;">
                        <span style="margin-top: 5px;">{{ items.backReasons ? JSON.parse(items.backReasons).map(item => {
      return `${item["问题内容"]}：${item["标注原因"]}`;
    }).join('\n') : '' }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box box-column-center" style="position: absolute; left: 0; right: 0; bottom: 0;border-top: 1px solid #dfe5e8;width: 100%;padding: 24px;">
                  <div class="box-1 box box-column-center">
                    <span>综合识别结果:</span>
                    <div class="rvalue" style="margin-left: 10px;">
                      <img v-if="item.aiAuditState == '已通过'" src="@/assets/image/rgPass.png" alt="">
                      <img v-if="item.aiAuditState == '不通过'" src="@/assets/image/rgNoPass.png" alt="">
                      <img v-if="item.aiAuditState == '待审核'" src="@/assets/image/daishenhe.png" alt="">
                      <img v-if="item.aiAuditState == '识别中'" src="@/assets/image/shibiez.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin: 0 5px;">
              <img src="@/assets/image/nextTo.png" alt="">
            </div>
            <!-- 审核页 -->
            <div
              class="box-1"
              style="border: 1px solid #E0E0E0;position: relative;"
              v-if="item.auditStateFlag == '待审核' && dialogType == '审核'"
            >
              <div class="box box-1 box-column-center citems">
                <img
                  src="@/assets/image/rengongshenhe.png"
                  style="width: 24px;height: 24px;"
                />
                <span class="dakaNums ml-10">人工审核</span>
              </div>
              <div class="box box-column" style="padding: 12px;height: 420px; overflow: auto;">
                <div v-for="(items, indexs) in item.auditFilejson" :key="indexs" class="mb-10">
                  <div style="border: 1px solid #dfe5e8;" class="box box-1">
                    <div class="box-1 box" style="position: relative;">
                      <el-image :src="items.url" class="box-1" style="height: 146px;" :preview-src-list="[items.url]"></el-image>
                      <el-button
                        v-if="items.state == '不合格'"
                        plain
                        type="text"
                        icon="el-icon-edit"
                        class="cl-white border-primary"
                        @click="startEditPic(items, indexs)"
                        style="position: absolute;left: 5px;bottom: 5px;"
                        :disabled="item.showAiFalg == 'Y'"
                        >标注</el-button
                      >
                    </div>
                    <div class="box-1 box box-column" style="justify-content: center;padding-left: 10px;">
                      <el-radio-group v-model="items.state" @change="changeStateValue" :disabled="item.showAiFalg == 'Y'">
                        <el-radio label="合格">合格</el-radio>
                        <el-radio label="不合格">不合格</el-radio>
                      </el-radio-group>
                      <el-select v-model="items.indexName" placeholder="请选择" multiple size="small" v-if="items.state == '不合格'" style="width: 200px;" :disabled="item.showAiFalg == 'Y'">
                        <el-option
                          v-for="itemos in options"
                          :key="itemos.id"
                          :label="itemos.zbmc"
                          :value="itemos.zbmc">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <div style="position: absolute; left: 0; right: 0; bottom: 0;border-top: 1px solid #dfe5e8;width: 100%;padding: 12px;">
                <div class="box box-column-center mb-20">
                  <span style="margin-right: 5px;width: 100px;text-align: right;">综合审核结果：</span>
                  <img
                      v-if="item.auditState == '已通过'"
                      src="@/assets/image/rgPass.png"
                      style="height: 24px;"
                    />
                    <!-- 不通过 -->
                    <img
                      v-if="item.auditState == '不通过'"
                      src="@/assets/image/rgNoPass.png"
                      style="height: 24px;"
                    />
                    <img v-if="item.auditState == '待审核'" src="@/assets/image/daishenhe.png" style="height: 24px;">
                </div>
                <div class="box mb-20">
                  <span style="margin-right: 5px;width: 100px;text-align: right;">审核意见：</span>
                  <el-input
                    class="box-1"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入"
                    v-model="item.auditOpinion"
                    :disabled="item.showAiFalg == 'Y'"
                  >
                  </el-input>
                </div>
                <div class="box" v-if="item.showAiFalg != 'Y'">
                  <span style="margin-right: 5px;width: 100px;text-align: right;"></span>
                  <div
                    class="box box-column-center"
                  >
                    <el-button style="font-size: 16px" @click="cancel" size="mini">
                      取消
                    </el-button>
                    <el-button
                      style="font-size: 16px;margin-right: 16px;"
                      @click="submit"
                      type="primary"
                      size="mini"
                    >
                      提交
                    </el-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- 详情页 -->
            <div class="box-1" style="border: 1px solid #E0E0E0;position: relative;" v-else>
              <div class="box box-1 box-column-center citems">
                <img
                  src="@/assets/image/rengongshenhe.png"
                  style="width: 24px;height: 24px;"
                />
                <span class="dakaNums ml-10">人工审核</span>
              </div>
              <div class="box box-column" style="padding: 12px;height: 420px; overflow: auto;">
                <div v-for="(items, indexs) in item.auditFilejson" :key="indexs" class="mb-10">
                  <div style="border: 1px solid #dfe5e8;" class="box box-1">
                    <div class="box-1 box">
                      <el-image :src="items.url" class="box-1" style="height: 146px;" :preview-src-list="[items.url]"></el-image>
                    </div>
                    <div class="box-1 box box-column" style="justify-content: center;padding-left: 10px;">
                      <img src="@/assets/image/hege.png" v-if="items.state == '合格'" alt="" style="width: 52px;height: 24px;">
                      <img src="@/assets/image/buhege.png" v-if="items.state == '不合格'" alt="" style="width: 52px;height: 24px;">
                      <span style="margin-top: 5px;" v-if="items.state == '不合格'">{{ items.indexName.join('、') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="position: absolute; left: 0; right: 0; bottom: 0;border-top: 1px solid #dfe5e8;width: 100%;padding: 12px;">
                <div class="box box-column-center box-between mb-10">
                  <div class="box box-column-center">
                    <img
                      src="@/assets/image/sh-tz.png"
                      style="width: 36px;height: 36px;"
                    />
                    <span class="shr ml-10"
                      >审核人：{{ item.auditUsername || '' }}</span
                    >
                  </div>

                  <!-- 编辑 在  为null  并且 communityAuditState 不为null 的时候显示 -->
                  <el-button type="primary" size="mini" v-if="(!item.adminAuditState || item.adminAuditState == '待审核') && roleData.find(ritem => ritem.label == '堆物堆料事项管理员' || ritem.label == '堆物堆料系统管理员') &&  dialogType == '审核'"  @click="editAuditState(index)">编辑</el-button>

                  <div class="box box-column-center">
                    <span style="margin-right: 5px;">综合审核结果</span>
                    <!-- 通过 -->
                    <img
                      v-if="item.auditState == '已通过'"
                      src="@/assets/image/rgPass.png"
                      style="height: 24px;"
                    />
                    <!-- 不通过 -->
                    <img
                      v-if="item.auditState == '不通过'"
                      src="@/assets/image/rgNoPass.png"
                      style="height: 24px;"
                    />
                    <img v-if="item.auditState == '待审核'" src="@/assets/image/daishenhe.png" style="height: 24px;">
                  </div>
                </div>
                <div class="result" style="padding: 12px;">
                  <div class="box box-column-center mb-10">
                    <span class="rlabel">审核时间:</span>
                    <div class="rvalue box-1 box box-wrap">
                      {{ item.auditTime }}
                    </div>
                  </div>
                  <div class="box box-column-center mb-10">
                    <span class="rlabel">审核意见:</span>
                    <div class="rvalue box-1 box box-wrap">
                      {{ item.auditOpinion }}
                    </div>
                  </div>
                  <div class="box box-column-center mb-10">
                    <span class="rlabel">事项名称:</span>
                    <div class="rvalue box-1 box box-wrap">
                      堆物堆料AI打卡
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 轮播图中标注 -->
    <el-dialog
      title="图片标注"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogTableVisible"
    >
      <ImageAnnotator
        v-if="dialogTableVisible"
        :currentClockItem="currentClockItem"
        @cancel="dialogTableVisible = false"
        @endEditPic="endEditPic"
      />
    </el-dialog>
  </div>
</template>

<script>
import MapCom from "./map.vue";
import ImageAnnotator from "./ImageAnnotator.vue";
import {
  indexPage,
  reportRecordDetail,
  reportRecordfullDetail,
  reportRecordAuditBatch,
} from "@/api/task.js";
import {
  getRoleUser,
} from "@/api/systemManagement";
export default {
  props: {
    dialogType: {
      type: String,
      default: ""
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ImageAnnotator,
    MapCom
  },
  data() {
    return {
      jzwListValue: {
        1: '高层公共建筑',
        2: '高层住宅及单多层建筑',
      },
      options: [],
      currentItem: {},
      detailHandleList: {
        reportAddressLong: "117.20391594886048",
        reportAddressLat: "39.116957599893084"
      },
      dialogTableVisible: false,
      currentIndex: 0,
      currentChildIndex: 0,
      currentClockItem: {},
      clockRecords: [],
      indexOfNums: {
        0: "一",
        1: "二",
        2: "三",
        3: "四",
        4: "五",
        5: "六",
        6: "七",
        7: "八",
        8: "九",
        9: "十",
      },
      // 审核结果选择
      auditStateList: [
        {
          value: "待审核",
          text: "待审核"
        },
        {
          value: "审核通过",
          text: "审核通过"
        },
        {
          value: "审核不通过",
          text: "审核不通过"
        }
      ],
      roleData: []
    };
  },
  mounted() {
    this.getrole();
    this.getItemInfo();
  },
  methods: {
    // 查询角色下拉列表
    async getrole() {
      let roles = JSON.parse(sessionStorage.getItem('userInfo')).roles;
      roles.map(item => {
        this.roleData.push({
          label: item.roleName,
          value: item.roleCode,
          id: item.id
        });
      });
    },
    changeStateValue () {
      if (this.clockRecords[this.currentIndex].auditFilejson.map(item => item.state).includes('不合格')) this.clockRecords[this.currentIndex].auditState = '不通过';
      else this.clockRecords[this.currentIndex].auditState = '已通过';
    },
    // 指标名称列表
    async eventPageFun() {
      let params = {
        zbmc: "",
        ghEventManageId: 'ID_MANGER_AI_DUIWUDUILIAO',
        page: 1,
        size: 9999,
      };
      const res = await indexPage(params);
      if (res.data.code == 200) {
        this.options = res.data.data.records
          ? res.data.data.records
          : [];
      }
    },
    // 获取单次ai识别
    async getFullDetail () {
      let params = {
        id: this.clockRecords[this.currentIndex].id || '',
        buildingId: this.item.buildingId,
        startTime: this.item.reportStartTime,
        endTime: this.item.reportEndTime,
      };
      const res = await reportRecordfullDetail(params);
      if (res.data.code == 200) this.clockRecords[this.currentIndex].aiTaskList = res.data.data.aiTaskList || [];
    },
    // 管理员修改
    editAuditState (index) {
      this.$set(this.clockRecords[index], 'auditStateFlag', '待审核');
      this.$forceUpdate();
    },
    // 获取总打卡次数及建筑物信息
    async getItemInfo() {
      let params = {
        buildingId: this.item.buildingId,
        startTime: this.item.reportStartTime,
        endTime: this.item.reportEndTime,
      };
      let res = await reportRecordDetail(params);
      this.currentItem = res.data.data;
      this.clockRecords =
        res.data.data && res.data.data.recordList && res.data.data.recordList.length
          ? JSON.parse(JSON.stringify(res.data.data.recordList))
          : [];
      if (this.clockRecords && this.clockRecords.length) {
        this.clockRecords.forEach(item => {
          item.auditState =  (item.adminAuditState && item.adminAuditState != '待审核') ? item.adminAuditState : (item.communityAuditState && item.communityAuditState != '待审核' ? item.communityAuditState : '待审核');
          item.auditStateFlag = item.auditState || '待审核';
          if ((!item.auditFilejson || item.auditFilejson == "[]") && (!item.auditState || item.auditState == '待审核') && this.dialogType == '审核' && item.fileJson) {
            let fileJson = JSON.parse(item.fileJson);
            fileJson.forEach(items => {
              items.state = '';
              items.indexName = [];
            })
            item.auditFilejson = fileJson;
          }
          if (item.auditFilejson && item.auditFilejson != "[]" && item.auditState != '待审核') item.auditFilejson = JSON.parse(item.auditFilejson);
        });
        this.eventPageFun();
      }
      if (this.clockRecords && this.clockRecords.length) this.getFullDetail();
    },
    // 开始标注
    startEditPic(items, indexs) {
      this.dialogTableVisible = true;
      this.currentClockItem = items;
      console.log(items)
      this.currentChildIndex = indexs;
    },
    // 提交标注
    endEditPic(e) {
      // if (e && e.auditFilejson) this.clockRecords[this.currentIndex].auditFilejson = e.auditFilejson;
      console.log(e)
      if (e && e.url) {
        this.clockRecords[this.currentIndex].auditFilejson[this.currentChildIndex].url = e.url;
        this.clockRecords[this.currentIndex].auditFilejson[this.currentChildIndex].filePath = e.filePath;
      }
      this.dialogTableVisible = false;
    },
    // 审核取消
    cancel() {
      this.$emit("closeDialog");
    },
    // 审核提交
    async submit() {
      let shanghuTaskList = {
        auditFilejson: this.clockRecords[this.currentIndex].auditFilejson ? JSON.stringify(this.clockRecords[this.currentIndex].auditFilejson) : '',
        auditOpinion: this.clockRecords[this.currentIndex].auditOpinion,
        auditState: this.clockRecords[this.currentIndex].auditState,
        id: this.clockRecords[this.currentIndex].id
      };
      let res = await reportRecordAuditBatch(shanghuTaskList);
      if (res.data.code == 200) {
        this.$message.success('提交成功');
        this.getItemInfo();
      } else this.$message.error(res.data.msg);
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/components/less.less";
.cl-primary {
  color: #008cff;
}
.topName {
  font-family: MiSans;
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0px;
  color: #494c4f;
}
.topThx {
  font-family: MiSans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: #0054fe;
}
.box {
  display: flex;
}
.box-1 {
  flex: 1;
}
.box-2 {
  flex: 2;
}
.box-3 {
  flex: 3;
}
.box-7 {
  flex: 7;
}
.box-wrap {
  flex-wrap: wrap;
}
.box-column {
  flex-direction: column;
}
.box-column-center {
  align-items: center;
}
.box-center {
  justify-content: center;
}
.box-center {
  justify-content: center;
  align-items: center;
}
.box-between {
  justify-content: space-between;
}
.border-bottom {
  border-bottom: 1px solid #e5eaf1;
}
.line {
  width: 100%;
  height: 16px;
  background: #f5f6f7;
}

.info {
  border-top: 1px solid #dfe5e8;
  border-left: 1px solid #dfe5e8;
  .item {
    padding: 14px 12px;
    border-right: 1px solid #dfe5e8;
    border-bottom: 1px solid #dfe5e8;
  }
  .item-right {
    padding: 14px 12px;
    border-right: 1px solid #dfe5e8;
    border-bottom: 1px solid #dfe5e8;
  }
  .item-bottom {
    padding: 14px 12px;
    border-bottom: 1px solid #dfe5e8;
  }
  .item-none {
    padding: 14px 12px;
  }
  .tagBg {
    background: #f1f4f6;
  }
}
.img-item {
  width: 88px;
  height: 88px;
  border-radius: 8px;
  margin: 0 8px 8px 0;
  position: relative;
  img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
  }
  span {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
    color: #ffffff;
    font-size: 13px;
    font-weight: 400;
    padding: 2px 0;
    border-radius: 0 0 8px 8px;
    text-align: center;
  }
  .delete {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 20px;
    cursor: pointer;
  }
}
.p-15 {
  padding: 15px;
}
.pb-10 {
  padding-bottom: 10px;
}
.pb-20 {
  padding-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-10 {
  margin-right: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.bold {
  font-weight: bold;
}
.w100 {
  width: 130px;
}
.mb-10 {
  margin-bottom: 10px;
}
.pointer {
  cursor: pointer;
}
.mt-16 {
  margin-top: 16px;
}

.title {
  height: 17px;
  font-family: MiSans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 18px;
  color: #494c4f;
  padding-left: 10px;
  position: relative;
  &::before {
    position: absolute;
    content: "";
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 4px;
    height: 17px;
    background: #0054fe;
  }
}

.clock-item {
  box-sizing: border-box;
  // border: 1px solid #dfe5e8;
  .citems {
    padding: 13px 24px;
    background: linear-gradient(0deg, #f1f4f6, #f1f4f6), #f7faff;
  }
  .dakaNums {
    font-family: MiSans;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0px;
    color: #494c4f;
  }
  .image {
    width: 110px;
    height: 110px;
    border-radius: 8px;
    margin-right: 8px;
  }
  .rlabel {
    font-family: MiSans;
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0px;
    color: #92979c;
    width: 80px;
  }
  .rvalue {
    font-family: MiSans;
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0px;
    color: #494c4f;
  }
  .shr {
    font-family: MiSans;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0px;
    color: #494c4f;
  }
  .result {
    padding: 20px 0px 20px 20px;
    background: #f3f7f9;
  }
}

.submitFlag {
  position: absolute;
  bottom: 0;
  right: 0;
}
.cl-primary {
  // color: #0054FE !important;
  color: #0495ff;
}

.border-primary {
  // border: 1px solid #0054FE !important;
  // border: 1px solid #0495ff;
  background: rgba(0, 0, 0, 0.5);
  padding: 2px 6px;
  font-family: MiSans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: #FFFFFF;
}

.p-10 {
  padding: 10px;
}
.bcl-white {
  background: #fff;
}
/deep/ .el-dialog {
  margin-top: 2vh !important;
  width: 700px !important;
}
/deep/ .el-dialog__body {
  max-height: 100vh;
}
/deep/ .el-dialog__wrapper {
  overflow: auto;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
}


.row-list {
  border-bottom: 1px solid #DFE5E8;
  padding-bottom: 15px;
}
.row-item {
  font-family: MiSans;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  letter-spacing: 0px;
  color: #92979C;
  padding-bottom: 15px;
  position: relative;
  cursor: pointer;
  margin-right: 30px;
}
.row-active {
  color: #494C4F !important;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 4px;
    border-radius: 2px;
    background: #0495FF;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mCheckInManage/dwdlClockList/detailForm.vue